// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	AddANewStatementButton: 'add-a-new-statement-button',
	ImportFromTeranetResultsButton: 'import-from-teranet-results-button',
	EditButton: 'edit-button',
	DeleteButton: 'delete-button',
	GoToPartiesButton: 'go-to-parties-button',
	DropdownOptions: 'dropdown-options',
	OpenDocumentDiv: 'open-document-div',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
